import { HStack, Section } from 'tio-ui/components/layout';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import DashResults from 'tio-employee/components/recommendations/dash-results';
import LinkedAccountsCard from 'tio-employee/components/accounts/linked-accounts-card';
import MonthlyPaymentForgivenessCard from 'tio-employee/components/recommendations/monthly-payment-forgiveness-card';
import TioRouteError from 'tio-common/components/tio/route-error';
import type { LoanSummary, SummaryByLoanType } from 'tio-common/types/loan-summary';
import type AccountModel from 'tio-data/models/account';
import type PersonModel from 'tio-data/models/person';
import type RecommendationModel from 'tio-data/models/recommendation';
import type UserModel from 'tio-data/models/user';

interface S {
  Args: {
    model: {
      accounts: AccountModel[];
      allRecommendations: RecommendationModel[];
      loanSummary: LoanSummary;
      mostRecentRecommendation?: RecommendationModel;
      person: PersonModel | null;
      user: UserModel | null;
    };
  };
}

export default class StrategyFinderDashboardIndexRoute extends Component<S> {
  get hasGraduatedPlan() {
    const summary = this.args.model.loanSummary;
    return summary.summaryByLoanType.some(
      (typeSummary: SummaryByLoanType) => typeSummary.repaymentPlan === 'graduated'
    );
  }

  <template>
    {{#if @model.person}}
      <HStack>
        <LinkedAccountsCard
          @accounts={{@model.accounts}}
          @loanSummary={{@model.loanSummary}}
          @person={{@model.person}}
          @programName={{t "common.strategy_finder.default"}}
          @source="strategy_finder"
          @providers="nslds"
        />

        {{#if this.hasGraduatedPlan}}
          <Section>
            <:body>
              {{t "pslf_dashboard.actions.dialog.graduated_plan"}}
            </:body>
          </Section>
        {{else if @model.user}}
          <MonthlyPaymentForgivenessCard
            @accounts={{@model.accounts}}
            @loanSummary={{@model.loanSummary}}
            @person={{@model.person}}
            @programType="sf"
            @user={{@model.user}}
            class="lg:col-span-4 col-span-6"
            @isCanceling={{false}}
          />
        {{/if}}
      </HStack>
      {{#if @model.mostRecentRecommendation}}
        <DashResults
          @accounts={{@model.accounts}}
          @allRecommendations={{@model.allRecommendations}}
          @loanSummary={{@model.loanSummary}}
          @person={{@model.person}}
          @programType="sf"
          @recommendation={{@model.mostRecentRecommendation}}
          class="lg:col-span-4 col-span-6"
        />
      {{/if}}
    {{else}}
      <TioRouteError
        @error="missing-person"
        @title={{t "route_error.title"}}
        @description={{t "route_error.description"}}
      />
    {{/if}}
  </template>
}
